import React from "react";
import { useTestPartner } from "../../hooks/useTestPartner";

function TestAccountBanner() {
  const { isTestPartner } = useTestPartner();
  
  if (!isTestPartner) return null;
  
  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4">
      <div className="flex items-center">
        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        <p className="font-semibold">Test Account - Read Only Mode</p>
      </div>
      <p className="text-sm mt-1">
        You are viewing this account in read-only mode. All write operations are disabled.
      </p>
    </div>
  );
}

export default TestAccountBanner;

